<template>
    <HeaderContent title="Room"/>
    <ActionContent ctaText="Add Room" @action="showModal" @showFilter="modalFilter = !modalFilter" :filterDate="true" v-model:start-date="startDate"  v-model:end-date="endDate" @search-query="searchData"/>
    <RoomStatistics title="Room Statistics" :data="statistics" />
    <RoomForm :modal="modal" :roomData="room" @update:modal="updateModal" @addOrUpdate="getAll"/>
    <RoomFilter :modalFilter="modalFilter" @update:modalFilter="modalFilter = $event" @filter-data="filterData"/>
    <RoomConfirm title="Confirmation" :uuid="roomUuid" @action="deleteData" :modalConfirm="modalConfirm" @update:modalConfirm="modalConfirm = $event">
      <template #text>Are you sure to delete this data ?</template>
    </RoomConfirm>
    <RoomDataTable :data="rooms" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
    <FormMaintenance v-if="modalMaintenance" v-model="modalMaintenance" :data="dataMaintenance"></FormMaintenance>
  </template>
  <script>
  
  import { ref, inject, onMounted, watch } from 'vue';
  import HeaderContent from '@/components/HeaderContent.vue';
  import ActionContent from '@/components/ActionContent.vue';
  import RoomForm from "./RoomForm.vue";
  import RoomFilter from "./RoomFilter.vue";
  import RoomStatistics from '@/components/StatisticRoom.vue';
  import RoomConfirm from '@/components/ModalDialog.vue';
  import RoomDataTable from '@/components/DataTable.vue';
  // import iconDeluxe from '../../../public/icons/business-value.svg';
  // import iconSuperDeluxe from '../../../public/icons/diamond.svg';
  // import iconStudio from '../../../public/icons/space-station-moon.svg';
  // import iconHoneymoon from '../../../public/icons/rings-wedding.svg';
  // import iconFamily from '../../../public/icons/family-pants.svg';
  import FormMaintenance from './FormMaintenance/FormMaintenance.vue';
  import {getToday, getCurrentMonth} from '@/composable/getDate.js'
  
  export default {
    components: {
      HeaderContent,
      ActionContent,
      RoomForm,
      RoomFilter,
      RoomConfirm,
      RoomStatistics,
      RoomDataTable,
      FormMaintenance
    },
    setup(){
      const repositories = inject('repositories');
      const roomRepository = repositories ? repositories.roomManagement : null;
      const roomCategoryRepository = repositories ? repositories.roomCategory : null;
      const modal = ref(false)
      const modalFilter = ref(false)
      const modalConfirm = ref(false)
      const roomUuid = ref(null)
      const modalMaintenance = ref(false)
      const dataMaintenance = ref({})
      const room = ref({})
      const rooms = ref([])
      
      // 
      const startDate = ref(getCurrentMonth())
      const endDate = ref(getToday())
      // alert(startDate.value)
      watch(startDate, () => {
        console.log('sd',startDate.value)
      })
      watch(endDate, () => {
        console.log('ed',endDate.value)
      })

    
      const headers = ref([
        {
          key: 'room_category',
          label: 'Room Type',
          sortable: true,
          tdClass: 'text-center w-25 px-5'
        },
        {
          key: 'room_code',
          label: 'Room Number',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          key: 'start',
          label: 'Start',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          key: 'end',
          label: 'End',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          key: 'status_room',
          label: 'Status',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        // {
        //   key: 'status_room',
        //   label: 'Status Room',
        //   sortable: true,
        //   tdClass: 'text-center'
        // },
        {
          key: 'action',
          label: 'Actions',
        }
      ])
      
      const customActions = ref([
        {
            label: 'Edit',
            variant: 'success',
            icon: 'fas fa-edit',
            action: (item) => {
              getById(item.uuid)
            }
        },
        {
            label: 'Set Maintenance',
            variant: 'warning',
            icon: 'fas fa-wrench',
            action: (item) => {
              console.log(item)
              dataMaintenance.value = {item}
              modalMaintenance.value = true
            }
        },
        {
            label: 'Delete',
            variant: 'danger',
            icon: 'fas fa-trash',
            action: (item) => {
              
              showConfirmModal(item.uuid)
            }
        },
      ])
  
      const statistics = ref([])
  
      const getListRoomCategory = async () => {
        await roomCategoryRepository.getAll().then((res) => {
          res.data.data.map((item) => {
            statistics.value.push({
                label: 'Total',
                key: item.name,
                value: item.rooms_count,
                color: item.color,
            })
            
          })
  
          console.log(statistics.value)
        }).catch(err => {
          console.error(err)
        })
      }
  
      const params = ref({
        search: '',
      })
  
      const getAll = async (start,end) => {
        await roomRepository.getAll(start,end).then((res) => {
          rooms.value = res.data.data
          console.log('room management', res)
          statistics.value = []
          getListRoomCategory()
        }).catch(err => {
          console.error(err)
        })
      }
      
      const getById = async (uuid) => {
        await roomRepository.getById(uuid).then((res) => {
          room.value = res.data.data
          room.value.room_category_uuid = res.data.data.room_category.uuid
          // console.log(room.value.room_category_uuid)
          modal.value = true
        }).catch(err => {
          console.error(err)
        })
      }
  
      const updateModal = (newValue) => {
        modal.value = newValue;
        room.value  = {}
      };
      
      const showModal = () => {
        modal.value = true
      }
      
      const showConfirmModal = async (uuid) => {
        modalConfirm.value = true
        roomUuid.value = uuid
        console.log(roomUuid.value)
      }
  
      const deleteData = async () => {
        await roomRepository.delete(roomUuid.value).then(() => {
          modalConfirm.value = false
          getAll()
        }).catch(err => {
          console.error(err)
        })
      }
  
      const searchData = async (keyword) => {
          await roomRepository.search(keyword).then((res) => {
              rooms.value = res.data.data
          }).catch(err => {
              console.error(err)
          })
      }
  
      const filterData = async (category, status) => {
          await roomRepository.filter(category, status).then((res) => {
              rooms.value = res.data.data
          }).catch(err => {
              console.error(err)
          })
      }
  
      onMounted(() => {
        getAll(getCurrentMonth(), getToday())
        
      })
  
      return{
        showModal,
        updateModal,
        getAll,
        getById,
        deleteData,
        params,
        rooms,
        room,
        roomUuid,
        headers,
        modal,
        modalFilter,
        modalConfirm,
        customActions,
        statistics,
        searchData,
        filterData,
        modalMaintenance,
        dataMaintenance,
        startDate,
        endDate,
        
      }
    }
  
  
  }
  </script>
  
  
  <style>
  
  </style>